export function createRunStream(
  runId: number,
  onChunk: (data: string) => void,
  onClose?: () => void
): () => void {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const ws = new WebSocket(`${protocol}//${window.location.host}/ws/runs/${runId}/stream`);

  ws.onmessage = (e) => onChunk(e.data);
  ws.onclose = () => onClose?.();
  ws.onerror = () => onClose?.();

  return () => ws.close();
}
